import React, { useState } from 'react';
import { Stack, IconButton, TextField } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

interface EditableSearchNameProps {
  name: string;
  onSave: (name: string) => void;
  isUpdating: boolean;
}

export default function EditableSearchName({ name, onSave, isUpdating }: EditableSearchNameProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editingName, setEditingName] = useState(name || '');

  const handleStartEdit = () => {
    setIsEditing(true);
    setEditingName(name || '');
  };

  const handleSave = () => {
    if (editingName.trim()) {
      onSave(editingName.trim());
    } else {
      setEditingName(name || '');
    }
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditingName(name || '');
  };

  if (isEditing) {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          value={editingName}
          onChange={(e) => setEditingName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSave();
            } else if (e.key === 'Escape') {
              handleCancel();
            }
          }}
          autoFocus
          size="small"
          sx={{ minWidth: '200px' }}
        />
        <IconButton
          onClick={handleSave}
          disabled={isUpdating}
          size="small"
          color="primary"
        >
          <CheckIcon />
        </IconButton>
        <IconButton
          onClick={handleCancel}
          disabled={isUpdating}
          size="small"
          color="error"
        >
          <CloseIcon />
        </IconButton>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <span>{name}</span>
      <IconButton
        onClick={handleStartEdit}
        size="small"
        sx={{ opacity: 0.7, '&:hover': { opacity: 1 } }}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
} 
